<script>
	import { nanoid } from "nanoid";

	import { validateField } from "../../../validation";

	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";

	// props
	export let id = nanoid(6);
	export let phoneNumber = null;
	export let phoneNumberLabel = "Phone number";
	export let phoneNumberSublabel = null;
	export let emailAddress = null;
	export let emailAddressLabel = "Email";
	export let emailAddressSublabel = null;
	export let disabled = null;

	let phoneNumberInput = null;
	let emailAddressInput = null;
</script>

<FormRow>
	<FormColumn>
		<label for="{id}_phoneNumber">
			{phoneNumberLabel}
			{#if !phoneNumber && !emailAddress}
				<span class="required">*</span>
			{/if}

			{#if phoneNumberSublabel}
				<div class="sublabel">{phoneNumberSublabel}</div>
			{/if}
		</label>
		<input
			phone
			class="form-control"
			type="tel"
			maxlength="20"
			id="{id}_phoneNumber"
			bind:this={phoneNumberInput}
			required={!phoneNumber && !emailAddress}
			{disabled}
			bind:value={phoneNumber}
			on:change={() => validateField(emailAddressInput)}
		/>
	</FormColumn>
	<FormColumn>
		<label for="{id}_emailAddress">
			{emailAddressLabel}
			{#if !phoneNumber && !emailAddress}
				<span class="required">*</span>
			{/if}

			{#if emailAddressSublabel}
				<div class="sublabel">{emailAddressSublabel}</div>
			{/if}
		</label>
		<input
			class="form-control"
			type="email"
			maxlength="50"
			id="{id}_emailAddress"
			bind:this={emailAddressInput}
			required={!phoneNumber && !emailAddress}
			{disabled}
			bind:value={emailAddress}
			on:change={() => validateField(phoneNumberInput)}
		/>
	</FormColumn>
</FormRow>
